export function reportVersion() {
  console.info(`account-service-web`
    + ` GIT_TAG: ${import.meta.env.VITE_GIT_TAG},`
    + ` GIT_COMMIT: ${import.meta.env.VITE_GIT_COMMIT}`);
}

export function reportServerVersion(gitTag?: string, gitCommit?: string) {
  console.info(`account-service-server`
    + ` GIT_TAG: ${gitTag},`
    + ` GIT_COMMIT: ${gitCommit}`);
}
